import { useStoryRolesAuth } from './useStoryRolesAuth';

type VisibilityBlok = GDoubleRowStoryblok | GFlexibleGridStoryblok | GSingleColumnStoryblok;

export function useBlokVisibility(blok: MaybeRef<VisibilityBlok | undefined>) {
    const { data: story } = useConfig();

    const { isAuthenticated } = useStoryRolesAuth(story);
    const isAuthenticatedClient = useClientGate(isAuthenticated);
    const { isDraftModeEnabled } = useDraftMode();

    const hidden = computed(() => {
        const b = unref(blok);

        if (isDraftModeEnabled.value) return false;

        return (
            (b?.visibility === 'before' && isAuthenticatedClient.value) ||
            (b?.visibility === 'after' && !isAuthenticatedClient.value)
        );
    });

    return {
        hidden
    };
}
